import { displayedBranchLabel } from '@/utils/dispatchBranchLabel'

export function packagingTypeLabel(t) {
  if (t === 'transparent_bag') return '透明袋'
  if (t === 'woven_bag') return '蛇皮袋'
  return '未指定'
}

export function fmtNumMaybe1(v) {
  if (v == null || Number.isNaN(Number(v))) return '0'
  const n = Number(v)
  const r = Math.round(n * 10) / 10
  if (Math.abs(r) < 0.0001) return '0'
  return r % 1 === 0 ? String(r) : r.toFixed(1)
}

export function parsePackWeightKg(s) {
  if (s == null || String(s).trim() === '') return null
  const n = parseFloat(String(s).replace(',', '.'))
  if (Number.isNaN(n)) return null
  return Math.round(n * 10) / 10
}

export function parsePackDimCm(s) {
  if (s == null || String(s).trim() === '') return null
  const n = parseInt(String(s).trim(), 10)
  return Number.isNaN(n) ? null : n
}

/** 订单行内部材料名称（品类） */
export function internalMaterialNameFromOrderItem(oi, itemExtra) {
  const src = oi || {}
  const mm = src.material_matching || {}
  const fromItem = itemExtra || {}
  return String(
    src.internal_product_name ||
      mm.material_category_name ||
      fromItem.material_category_name ||
      ''
  ).trim()
}

/** 订单行内部中英文颜色 */
export function internalColorLineFromOrderItem(oi) {
  const cn = (oi || {}).internal_color_cn || ''
  const en = (oi || {}).internal_color_en || ''
  if (!cn && !en) return ''
  return [cn && `中 ${cn}`, en && `英 ${en}`].filter(Boolean).join(' · ')
}

/** 从派工单详情构建按支包装实测行（桌面/移动共用） */
export function buildPackLinesFromDispatchOrder(data) {
  const o = data
  const dispatchNo = o?.dispatch_order_no || ''
  const lines = []
  const list = Array.isArray(o?.items) ? o.items : []
  for (const it of list) {
    const brs = it.branch_records || []
    const itemNeedW = !!(it.packaging_require_weigh ?? o.packaging_require_weigh)
    const itemNeedV = !!(it.packaging_require_volume ?? o.packaging_require_volume)
    const oi = it.order_item || {}
    const unit = oi.unit_name || ''
    const internalMaterialName = internalMaterialNameFromOrderItem(oi, it)
    const internalColorLine = internalColorLineFromOrderItem(oi)
    const customerName = String(it.customer_name || oi.customer_name || '').trim()
    for (const br of brs) {
      const needW = !!(br.packaging_need_weigh ?? itemNeedW)
      const needV = !!(br.packaging_need_volume ?? itemNeedV)
      lines.push({
        branch_record_id: br.branch_record_id,
        branch_pack_code: br.branch_pack_code || '',
        order_no: it.order_no || '',
        client_purchase_order: it.client_purchase_order || '',
        customerName,
        branch_label: br.branch_label || '',
        displayLabel: displayedBranchLabel(br, dispatchNo),
        internalMaterialName,
        internalColorLine,
        packagingMeasuredByName: br.packaging_measured_by_name || '',
        packagingMeasuredAt: br.packaging_measured_at || '',
        quantity: br.quantity,
        unit,
        needWeigh: needW,
        needVolume: needV,
        weightStr: br.weight_kg != null ? fmtNumMaybe1(br.weight_kg) : '',
        lenStr: br.length_cm != null ? String(Math.round(Number(br.length_cm))) : '',
        widStr: br.width_cm != null ? String(Math.round(Number(br.width_cm))) : '',
        hgtStr: br.height_cm != null ? String(Math.round(Number(br.height_cm))) : ''
      })
    }
  }
  return lines
}

export function orderNeedsPackMeasures(order) {
  if (!order) return false
  if (order.packaging_require_weigh || order.packaging_require_volume) return true
  const items = Array.isArray(order.items) ? order.items : []
  return items.some((it) => it.packaging_require_weigh || it.packaging_require_volume)
}
